import { render, staticRenderFns } from "./WsMain.vue?vue&type=template&id=e8c0826e&"
import script from "./WsMain.vue?vue&type=script&lang=js&"
export * from "./WsMain.vue?vue&type=script&lang=js&"
import style0 from "./WsMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports